import RouteTemplate from 'ember-route-template';

import { hash } from '@ember/helper';
import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';
import { pageTitle } from 'ember-page-title';

import ReloadModel from 'rise-ui/components/reload-model.gjs';
import or from 'rise-ui/helpers/or.js';
import { readOnly } from 'rise-ui/utils/object/computed.js';

export default RouteTemplate(class HelpIndexTemplate extends Component {
  @readOnly('@model.helpTopicField') helpTopicField;
  get helpTopics() {
    return Object.entries(this.helpTopicField?.allowedValues || {})
      .map(([ id, title ]) => ({ id, title }));
  }
  @readOnly('helpTopicField.isPending') helpTopicsLoading;
  @readOnly('helpTopicField.isRejected') helpTopicsHaveError;
  @readOnly('helpTopicField.reason') helpTopicsError;

  <template>
    {{pageTitle "Help Search"}}

    <h3 class="c-page-title qa-page-title">Topics</h3>
    <div class="id-help-topics">
      {{#if this.helpTopicsHaveError}}
        <div class="c-no-result id-help-topics__error qa-help-error">
          Error fetching help topics. <ReloadModel>Retry</ReloadModel>
        </div>
      {{else}}
        {{#each this.helpTopics as | topic |}}
          {{#if topic.id}}
            <div class="c-media">
              <div class="c-media__body">
                <div class="c-media__head">
                  <h4 class="c-media__title">
                    <LinksTo @route="help.search"
                      @query={{hash topic=(or topic.id undefined) search=undefined}}
                    >{{topic.title}}</LinksTo>
                  </h4>
                </div>
              </div>
            </div>
          {{/if}}
        {{else}}
          {{#if this.helpTopicsLoading}}
            <div class="c-no-result id-help-topics__init qa-help-loading">Loading Help Topics...</div>
          {{else}}
            <div class="c-no-result id-help-topics__empty qa-help-empty">No help topics found</div>
          {{/if}}
        {{/each}}
      {{/if}}

      {{outlet}}
    </div>
  </template>
});
